module.exports = __webpack_public_path__ + "static/img/Christian_Petracca_mobile.bfce872.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Christian_Petracca_mobile.jpg
// module id = Jz27
// module chunks = 0